module.exports = __webpack_public_path__ + "static/media/tablet-rugged.894a226f.svg";